/**
 * Whether the page was reached by navigating within this document (a link, a redirect, or
 * Back/Forward), as opposed to the document's own load, reload, or restored session.
 *
 * React Router keys each entry it pushes (`history.state.key`) and keeps the key across
 * reloads, so the persisted index alone can't tell a reload from a navigation. A different
 * key than the one the document loaded on means a push; a `popstate` since load means
 * Back/Forward, including Back to the loaded entry. main.tsx imports this module first, so
 * the key is read and the listener attached before the router starts.
 */
type RouterState = { key?: string } | null;

const loadedKey = typeof window === "undefined" ? undefined : (window.history.state as RouterState)?.key;
let traversed = false;
if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    traversed = true;
  });
}

export function arrivedByNavigation(): boolean {
  return traversed || (window.history.state as RouterState)?.key !== loadedKey;
}
